// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LedgerPaidBy from './data'

export default function LedgerPaidByFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LedgerPaidBy">
      <LedgerPaidBy {...props}>
        {children}
      </LedgerPaidBy>
    </Flow>
  )
}
